import classNames from "classnames";
import {motion} from "motion/react";
import {FiChevronRight} from "react-icons/fi";

import {getInitials} from "@/lib/format.tsx";
import {AccountUser} from "@/lib/types/accounts.ts";

import styles from "./NavBarProfileButtonContent.module.scss";

interface NavbarProfileButtonContentProps {
  user: AccountUser;
  show: boolean;
}

export const NavBarProfileButtonContent = ({user, show}: NavbarProfileButtonContentProps) => {
  return (
    <div className={"w-100 d-flex align-items-center justify-content-between"}>
      <div className="align-items-center">
        <span className={classNames("ms-1", styles.profileInitials)}>
          {getInitials(user.first_name, user.last_name)}
        </span>
        <span className={styles.profileName}>{`${user.first_name} ${user.last_name[0]}.`}</span>
      </div>
      <div className={styles.profileName}>
        <motion.div
          className={"ms-auto"}
          initial={{rotate: show ? 180 : 0}}
          animate={{rotate: show ? 180 : 0}}
          transition={{
            type: "tween",
          }}
        >
          <FiChevronRight />
        </motion.div>
      </div>
    </div>
  );
};
